import { CONVERSATION_TYPES } from '../model/api/constants';
import type { ConversationTypeEnum } from '../model/api/types';

/** Диалог — текстовая коммуникация: вместо записи и расшифровки у него переписка. */
export const isTextConversation = (conversation?: { conversationType?: ConversationTypeEnum | null } | null): boolean =>
  conversation?.conversationType === CONVERSATION_TYPES.TEXT;
